import { Course, Genre, Menu, MenuBook, SubGenre, SubMenu, SubMenuGroup } from '../../models';
import ChildSubMenuGroupRow from '../ChildSubMenuGroupRow';
import ChildSubMenuRowList from '../ChildSubMenuRowList';

export interface ChildSubMenuGroupRowListProps {
  menuBook: MenuBook;
  course?: Course;
  genre: Genre;
  subgenre: SubGenre;
  menu: Menu;
  subMenuGroup: SubMenuGroup;
  subMenu: SubMenu;
}

function ChildSubMenuGroupRowList({
  menuBook,
  course,
  genre,
  subgenre,
  menu,
  subMenuGroup,
  subMenu,
}: ChildSubMenuGroupRowListProps) {
  return (
    <>
      {subMenu.child_sub_menu_groups.map((childSubMenuGroup) => (
        <ChildSubMenuGroupRow
          key={`childsubmenugroup-${childSubMenuGroup.id}`}
          menuBook={menuBook}
          course={course}
          genre={genre}
          subgenre={subgenre}
          menu={menu}
          subMenuGroup={subMenuGroup}
          subMenu={subMenu}
          childSubMenuGroup={childSubMenuGroup}
        >
          <ChildSubMenuRowList
            menuBook={menuBook}
            course={course}
            genre={genre}
            subgenre={subgenre}
            menu={menu}
            subMenuGroup={subMenuGroup}
            subMenu={subMenu}
            childSubMenuGroup={childSubMenuGroup}
          />
        </ChildSubMenuGroupRow>
      ))}
    </>
  );
}

export default ChildSubMenuGroupRowList;
